import SimpleBar from 'simplebar-react';
import './home-content.css';
import edunexus from '../../../../../../assets/edunexus.png';
import { CourseCardProgress } from '../../../../../../components/CourseCard/CourseCard';
import { Annoucement, Course, Deadline } from '../../../../../../types';
import DeadlineCard from '../../../../../../components/DeadlineCard/DeadlineCard';
import AnnouncementCard from '../../../../../../components/AnnouncementCard/AnnouncementCard';
function HomeContent() {
    const courseList: Course[] = [
        { id: '1', title: 'Course Name', teacher: 'Teacher Name', image: edunexus, progress: 100 },
        { id: '2', title: 'Course Name', teacher: 'Teacher Name', image: edunexus, progress: 50 },
        { id: '3', title: 'Course Name', teacher: 'Teacher Name', image: edunexus, progress: 45 },
        { id: '4', title: 'Course Name', teacher: 'Teacher Name', image: edunexus, progress: 99 },
    ];

    const deadlineList: Deadline[] = [
        { id: '1', name: 'Deadline teste', date: '27/10/2025 - 12:46', icon: 'fa-solid fa-folder' },
        { id: '2', name: 'Deadline sdfsd', date: '29/10/2025 - 10:00', icon: 'fa-solid fa-folder' },
        { id: '3', name: 'Deadline Name', date: '29/10/2025 - 10:00', icon: 'fa-solid fa-folder' },
        { id: '4', name: 'Deadline sdfsdf', date: '13/10/2025 - 20:20', icon: 'fa-solid fa-folder' },
    ];

    const announcementList: Annoucement[] = [
        { id: '1', name: 'Announcement Name', date: '27/10/2025 - 12:46', description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. dfgdfgdfdfghdfgdfgdfgdfgdfgdfgdfgdfgd. Lorem ipsum dolor sit amet, consectetur adipiscing elit.' },
        { id: '2', name: 'Announcement Name', date: '29/10/2025 - 10:00', description: 'Announcement Description' },
        { id: '3', name: 'Announcement Name', date: '29/10/2025 - 10:00', description: 'Announcement Description' },
        { id: '4', name: 'Announcement Name', date: '13/10/2025 - 20:20', description: 'Announcement Description' },
    ];

    return (
        <>
            <h1>Dashboard</h1>

            <section className="my-courses">
                <h2>My Courses</h2>

                <div className="list-container">
                    <SimpleBar className="scrolling">
                        <div className="list">
                            {courseList.map((course) => (
                                <CourseCardProgress 
                                    key={course.id} 
                                    {...course} 
                                />
                            ))}
                        </div>
                    </SimpleBar>
                </div>

            </section>

            <div className="announcements-deadlines">
                <section className="deadlines">
                    <h2>Deadlines</h2>

                    <div className="list">
                        {deadlineList.map((deadline) => (
                            <DeadlineCard 
                                key={deadline.id} 
                                {...deadline} 
                            />
                        ))}
                    </div>
                </section>

                <section className="announcements">
                    <h2>Announcements</h2>

                    <div className="list">
                        {announcementList.map((announcement) => (
                            <AnnouncementCard 
                                key={announcement.id} 
                                {...announcement} 
                            />
                        ))}
                    </div>
                </section>
            </div>
        </>
    );
}

export default HomeContent;